(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('facet-filters')) {
    customElements.define(
      'facet-filters',
      class FacetFilters extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-facets-form]');
          this.sectionId = this.dataset.sectionId;

          this.form.addEventListener('change', (event) => {
            // Price fields apply when the customer leaves the field (change), not on each key.
            window.clearTimeout(this.debounce);
            this.debounce = window.setTimeout(() => this.apply(), event.target.type === 'number' ? 0 : 150);
          });
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.apply();
          });
          this.addEventListener('click', (event) => {
            const link = event.target.closest('[data-facets-link]');
            if (!link) return;
            event.preventDefault();
            this.render(link.href);
          });
          // Only one panel open at a time.
          this.addEventListener(
            'toggle',
            (event) => {
              if (!event.target.open) return;
              this.querySelectorAll('details[open]').forEach((details) => {
                if (details !== event.target) details.open = false;
              });
            },
            true
          );

          this.onDocumentClick = (event) => {
            if (!this.contains(event.target)) this.closePanels();
          };
          this.onKeyUp = (event) => {
            if (event.key === 'Escape') this.closePanels(true);
          };
          this.onPopState = () => this.render(window.location.href, false);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keyup', this.onKeyUp);
          window.addEventListener('popstate', this.onPopState);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keyup', this.onKeyUp);
          window.removeEventListener('popstate', this.onPopState);
        }

        closePanels(returnFocus = false) {
          this.querySelectorAll('details[open]').forEach((details) => {
            details.open = false;
            if (returnFocus) details.querySelector('summary').focus();
          });
        }

        apply() {
          const params = new URLSearchParams(new FormData(this.form));
          for (const [key, value] of [...params.entries()]) {
            if (value === '') params.delete(key);
          }
          const action = new URL(this.form.action, window.location.origin);
          this.render(`${action.pathname}?${params.toString()}`);
        }

        async render(url, pushState = true) {
          // This is the latest choice: a ticked box still waiting to apply would be sent after it and undo it (a chip or
          // "Limpar filtros" tapped within the wait; until 2026-10-08 it was).
          window.clearTimeout(this.debounce);
          const target = new URL(url, window.location.origin);
          const request = new URL(target);
          request.searchParams.set('section_id', this.sectionId);
          // Only the latest choice may update the page; an earlier one answered later is dropped.
          const token = Symbol('render');
          this.renderToken = token;

          const root = document.getElementById(`shopify-section-${this.sectionId}`);
          root.setAttribute('aria-busy', 'true');
          const openKey = this.querySelector('details[open]')?.dataset.filterKey;
          const focused = document.activeElement;
          const focusSelector =
            focused && this.contains(focused) && focused.name
              ? `[name="${CSS.escape(focused.name)}"]${focused.value ? `[value="${CSS.escape(focused.value)}"]` : ''}`
              : null;

          try {
            const response = await fetch(request);
            // An error page has none of the regions: load the filtered page normally instead of emptying them.
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const text = await response.text();
            if (token !== this.renderToken) return;
            const html = new DOMParser().parseFromString(text, 'text/html');
            root.querySelectorAll('[data-facets-replace]').forEach((element) => {
              // Nested targets (e.g. "more" inside "grid") were already replaced with their parent.
              if (!element.isConnected) return;
              const fresh = html.querySelector(`[data-facets-replace="${element.dataset.facetsReplace}"]`);
              if (fresh) element.replaceWith(fresh);
              else element.replaceChildren();
            });
            if (openKey) {
              const details = this.querySelector(`details[data-filter-key="${CSS.escape(openKey)}"]`);
              if (details) details.open = true;
            }
            if (focusSelector) this.querySelector(focusSelector)?.focus({ preventScroll: true });
            if (pushState) window.history.pushState({}, '', target.pathname + target.search);
          } catch (error) {
            if (token === this.renderToken) window.location.href = target.href;
          } finally {
            if (token === this.renderToken) root.removeAttribute('aria-busy');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('load-more-button')) {
    customElements.define(
      'load-more-button',
      class LoadMoreButton extends HTMLElement {
        connectedCallback() {
          this.link = this.querySelector('[data-load-more-link]');
          this.link.addEventListener('click', (event) => {
            event.preventDefault();
            this.load();
          });
        }

        async load() {
          const grid = document.getElementById(this.dataset.grid);
          const section = this.closest('.shopify-section');
          if (!grid || !section) return;
          const sectionId = section.id.replace('shopify-section-', '');
          const url = new URL(this.link.href, window.location.origin);
          url.searchParams.set('section_id', sectionId);

          this.link.setAttribute('aria-busy', 'true');
          this.link.textContent = 'Carregando…';
          try {
            const response = await fetch(url);
            // An error answer, or one without the grid, cannot be added in place: open the next page instead.
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const text = await response.text();
            // A filter or sort change replaced the list meanwhile: this answer belongs to the old one.
            if (!this.isConnected || !grid.isConnected) return;
            const html = new DOMParser().parseFromString(text, 'text/html');
            const freshGrid = html.getElementById(this.dataset.grid);
            if (!freshGrid) throw new Error('No product grid in the answer');
            const firstNew = freshGrid.firstElementChild;
            grid.append(...freshGrid.children);
            // Keep keyboard users in place: move focus to the first new product.
            firstNew?.querySelector('a[href]:not([tabindex="-1"])')?.focus({ preventScroll: true });

            const freshMore = html.querySelector('[data-facets-replace="more"]');
            // Counted from the page opened (?page=2 starts at 25), not from the first product.
            const offset = Number(this.dataset.offset) || 0;
            const shown = offset + grid.children.length;
            const total = Number(this.dataset.total);
            if (freshMore) {
              // The next button counts from where this list started too, not from the page it was rendered for.
              freshMore.querySelector('load-more-button')?.setAttribute('data-offset', offset);
              freshMore.querySelector('[data-load-more-shown]').textContent = shown;
              freshMore.querySelector('[data-load-more-bar]').style.width = `${Math.round((shown / total) * 100)}%`;
              section.querySelector('[data-facets-replace="more"]').replaceWith(freshMore);
            }
            const count = section.querySelector('[data-results-range]');
            if (count) count.textContent = `${offset + 1}–${shown}`;
          } catch (error) {
            if (this.isConnected) window.location.href = this.link.href;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-form')) {
    customElements.define(
      'search-form',
      class SearchForm extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[name="q"]');
          this.form = this.querySelector('form');
          this.setUpVoice();
          if (this.dataset.predictiveUrl) this.setUpSuggestions();
        }

        setUpVoice() {
          const voiceButton = this.querySelector('[data-voice-search]');
          const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
          if (!voiceButton || !Recognition) return;

          voiceButton.hidden = false;
          voiceButton.addEventListener('click', () => {
            const recognition = new Recognition();
            recognition.lang = document.documentElement.lang || 'pt-BR';
            recognition.interimResults = false;
            recognition.maxAlternatives = 1;
            recognition.onstart = () => voiceButton.classList.add('is-listening');
            recognition.onend = () => voiceButton.classList.remove('is-listening');
            recognition.onerror = () => voiceButton.classList.remove('is-listening');
            recognition.onresult = (event) => {
              this.input.value = event.results[0][0].transcript;
              this.form.requestSubmit();
            };
            recognition.start();
          });
        }

        // Suggestions while typing (design spec, "Suggestions while typing"): from the second letter, 150 ms after
        // the last key. Only the answer to the text in the field shows: each request takes a number, and an answer
        // is dropped when a newer request was made, the panel was closed or the field no longer holds its text.
        setUpSuggestions() {
          this.panel = this.querySelector('[data-predictive-panel]');
          this.status = this.querySelector('[data-predictive-status]');
          this.request = 0;
          this.options = [];
          this.active = -1;
          this.shownTerms = null;

          this.input.addEventListener('input', () => this.schedule());
          this.input.addEventListener('focus', () => {
            if (this.shownTerms !== null && this.shownTerms === this.terms()) this.open();
          });
          this.input.addEventListener('keydown', (event) => this.onKeydown(event));
          document.addEventListener('pointerdown', (event) => {
            if (!this.contains(event.target)) this.close();
          });
        }

        terms() {
          return this.input.value.trim();
        }

        schedule() {
          clearTimeout(this.timer);
          const terms = this.terms();
          if (terms.length < 2) {
            this.close();
            return;
          }
          this.timer = setTimeout(() => this.fetchSuggestions(terms), 150);
        }

        async fetchSuggestions(terms) {
          this.request += 1;
          const request = this.request;
          const url = new URL(this.dataset.predictiveUrl, window.location.origin);
          url.searchParams.set('q', terms);
          url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          url.searchParams.set('section_id', 'predictive-search');
          try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (request !== this.request || terms !== this.terms()) return;
            const content = html.querySelector('[data-predictive-content]');
            if (!content) throw new Error('No suggestions in the answer');
            this.show(content, terms);
          } catch (error) {
            // Enter still searches; the suggestions just stay closed.
            if (request === this.request) this.close();
          }
        }

        show(content, terms) {
          this.panel.replaceChildren(content);
          this.options = [...this.panel.querySelectorAll('[role="option"]')];
          this.options.forEach((option, index) => {
            option.id = `${this.panel.id}-option-${index}`;
          });
          this.shownTerms = terms;
          const count = Number(content.dataset.count || 0);
          this.status.textContent = count ? `${count} ${count === 1 ? 'produto sugerido' : 'produtos sugeridos'}` : 'Nenhum produto sugerido';
          this.open();
        }

        open() {
          this.mark(-1);
          this.panel.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
        }

        // Closing also drops the request on its way and the one waiting for the 150 ms.
        close() {
          clearTimeout(this.timer);
          this.request += 1;
          this.mark(-1);
          this.panel.hidden = true;
          this.input.setAttribute('aria-expanded', 'false');
        }

        mark(index) {
          this.options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
          this.active = index;
          if (index < 0) {
            this.input.removeAttribute('aria-activedescendant');
            return;
          }
          this.input.setAttribute('aria-activedescendant', this.options[index].id);
          this.options[index].scrollIntoView({ block: 'nearest' });
        }

        onKeydown(event) {
          // Leaving the field also drops a request still on its way, before the panel ever opened.
          if (event.key === 'Tab') {
            this.close();
            return;
          }
          if (this.panel.hidden) return;
          const last = this.options.length - 1;
          switch (event.key) {
            case 'ArrowDown':
              event.preventDefault();
              if (last >= 0) this.mark(this.active >= last ? 0 : this.active + 1);
              break;
            case 'ArrowUp':
              event.preventDefault();
              if (last >= 0) this.mark(this.active <= 0 ? last : this.active - 1);
              break;
            case 'Enter':
              if (this.active >= 0) {
                event.preventDefault();
                this.options[this.active].click();
              }
              break;
            case 'Escape':
              // The panel only: inside the menu drawer the drawer stays open.
              event.preventDefault();
              event.stopPropagation();
              this.close();
              break;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
